import { TR_BIO } from './bio.js';
import { TR_HANDLE_ADJECTIVES, TR_HANDLE_NOUNS, TR_HANDLE_WORDS, TR_PLACE_CODES } from './handles.js';
import { TR_FEMALE_NAMES, TR_MALE_NAMES, TR_SURNAMES } from './names.js';
import type { LocalePack } from '../types.js';

const TR = 'tr-TR';

const FOLD: Record<string, string> = {
  ç: 'c', Ç: 'C', ğ: 'g', Ğ: 'G', ı: 'i', İ: 'I', ö: 'o', Ö: 'O', ş: 's', Ş: 'S', ü: 'u', Ü: 'U',
  â: 'a', Â: 'A', î: 'i', Î: 'I', û: 'u', Û: 'U',
};

/** Strip Turkish letters to ASCII the way a user typing a handle would (ş→s, ı→i). */
function asciiFold(s: string): string {
  return s.replace(/[çÇğĞıİöÖşŞüÜâÂîÎûÛ]/g, (c) => FOLD[c] ?? c);
}

/** The Turkish synthetic-profile vocabulary (TaksimChatFun's market). */
export const trPack: LocalePack = {
  locale: 'tr',
  names: { female: TR_FEMALE_NAMES, male: TR_MALE_NAMES, surnames: TR_SURNAMES },
  asciiFold,
  lower: (s) => s.toLocaleLowerCase(TR),
  upper: (s) => s.toLocaleUpperCase(TR),
  handle: {
    words: TR_HANDLE_WORDS,
    adjectives: TR_HANDLE_ADJECTIVES,
    nouns: TR_HANDLE_NOUNS,
    placeCodes: TR_PLACE_CODES,
  },
  bio: TR_BIO,
};
